<template>
  <!-- eslint-disable -->
  <div>
    <b-card no-body>
      <b-card-body>
        <b-row>
          <b-col md="2" class="mb-md-0 mt-2">
          <b-button variant="gradient-danger" @click="back">
            <feather-icon icon="ArrowLeftIcon" class="mr-50" />
            <span class="align-middle">Atras</span>
          </b-button>
          </b-col>
        </b-row>
      </b-card-body>
    </b-card>
  </div>
</template>

<script>
/* eslint-disable*/
import { BCard, BCardHeader, BCardBody, BRow, BCol, BButton,BFormGroup, BFormInput } from 'bootstrap-vue'
import vSelect from 'vue-select'
import Ripple from 'vue-ripple-directive'
export default {
  directives: {
    Ripple
  },
  data() {
    return {
      name: '',
      arrayFilters: [],
    }
  },
  components: {
    BButton,
    BFormInput,
    BFormGroup,
    BRow,
    BCol,
    BCard,
    BCardHeader,
    BCardBody,
    vSelect,
  },
  mounted() {
  },
  methods: {
    addModelo(){
      this.isAdd = true
      this.$refs.modelosAdd.getData({})
    },
    back() {
      this.$router.push({ name: 'stock-list' })
    },
    async filter() {
      this.arrayFilters = [];
      if (this.name !== '') {
        this.arrayFilters.push({
          keyContains: 'establishments.name',
          key: 'contains',
          value: this.name
        });
      }
      this.$parent.$parent.arrayFilters = this.arrayFilters
      this.$parent.$parent.getData();
    },
    clean() {
      this.name = '';
      this.arrayFilters = [];
      this.$parent.$parent.arrayFilters = this.arrayFilters
      this.$parent.$parent.getData();
    },
    async getVehicleName() {
      const vehicleId = parseInt(this.$route.params.id); 
      const vehicleResp = await VehicleService.getVehicleById(vehicleId, this.$store); 
      if (vehicleResp && vehicleResp.data) {
        this.vehicleName = vehicleResp.data.name;
      }
    }
  }
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>
